import useOperationStaffController from "../../../../controllers/operationStaff-controller";
import {useEffect, useMemo} from "react";
import {OPERATION_STAFF_ROLES} from "../../../../enums/operationStaffRoles";
import useOperationRoomsController from "../../../../controllers/operationRooms-controller";
import {SurgeryRequestsFromData, SurgeryRequestsFromServiceProps} from "./types";
import {SurgeryRequestItem} from "../../../../types/surgeryRequests";
import {useAuth} from "../../../../context/authContext";
import {anesthesiaFieldOptions, bloodTypeFieldOptions} from "./options";

const useFormService = (props: SurgeryRequestsFromServiceProps) => {
  const {createSurgeryRequestHandler, updateSurgeryRequestHandler, selectedItem} = props
  const {operationStaffList, fetchOperationStaffList} = useOperationStaffController()
  const {operationRoomSelectOptions} = useOperationRoomsController()
  const {currentUser} = useAuth();


  useEffect(() => {
    fetchOperationStaffList([])
  }, [])


  const staffFieldsOptions = useMemo(() => {

    return {
      surgeonOptions: operationStaffList?.filter((staffItem) => staffItem.role?.includes(OPERATION_STAFF_ROLES.SURGEON)).map((staffItem) => {
        return {
          label: staffItem.fullName,
          value: staffItem.$id
        }
      }) || [],
      assistantOptions: operationStaffList.filter((staffItem) => staffItem.role?.includes(OPERATION_STAFF_ROLES.ASSISTANT)).map((staffItem) => {
        return {
          label: staffItem.fullName,
          value: staffItem.$id
        }
      }) || [],
      anesthesiologistOptions: operationStaffList.filter((staffItem) => staffItem.role?.includes(OPERATION_STAFF_ROLES.ANESTHESIOLOGIST)).map((staffItem) => {
        return {
          label: staffItem.fullName,
          value: staffItem.$id
        }
      }) || [],
      scrubNurseOptions: operationStaffList.filter((staffItem) => staffItem.role?.includes(OPERATION_STAFF_ROLES.SCRUB_NURSE)).map((staffItem) => {
        return {
          label: staffItem.fullName,
          value: staffItem.$id
        }
      }) || [],
      anesthesiaNurseOptions: operationStaffList.filter((staffItem) => staffItem.role?.includes(OPERATION_STAFF_ROLES.ANESTHESIA_NURSE)).map((staffItem) => {
        return {
          label: staffItem.fullName,
          value: staffItem.$id
        }
      }) || [],
    }
  }, [operationStaffList])


  const onFinishHandler = async (formData: SurgeryRequestsFromData) => {
    const correctFormData = {
      ...formData,
      operationTime: formData.operationTime.toISOString(),
      createdById: currentUser?.id as string,
      bloodType: formData.bloodType || null,
      diagnosis: formData.diagnosis || null,
      anesthesia: formData.anesthesia || null,
      author: currentUser?.name,
    } as unknown as SurgeryRequestItem
    if (selectedItem?.$id) {
      await updateSurgeryRequestHandler({...correctFormData, $id: selectedItem?.$id})
    } else {
      await createSurgeryRequestHandler(correctFormData)
    }


  }

  return {
    bloodTypeFieldOptions,
    onFinishHandler,
    staffFieldsOptions,
    anesthesiaFieldOptions,
    operationRoomSelectOptions
  }
}

export default useFormService